export default __webpack_public_path__ + "static/media/alat.8f66a9cf.pdf";